module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication1",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }), _vm._v("IN FOND MEMORY OF IAN AND SAM,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("TO CHRIS AS ALWAYS,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("AND TO BARBARA, ANITA, JOAN AND REYN,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("MANY THANKS.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c2647ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781446359211_epub_ded_r1.vue
// module id = 60
// module chunks = 0